import React, { useContext } from 'react';
import { Button, Modal, Tooltip, Typography, message } from 'antd';
import { EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { TOUR_TRASH_TRANSLATION } from '../../../../constants/define/translation';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';
import { UserContext } from '../../../../repository/context/userContext';
import { TourTrashStatusType, TourTrashType } from '../../../../types/tourtrash';

interface IndexColumnProps {
  record: TourTrashType;
  onHandleClickBtnEdit?: (record: TourTrashType, editTourTrashActive?: boolean) => void;
  setLoading?: (value: boolean) => void;
}

export default React.memo((props: IndexColumnProps) => {
  const { t } = useTranslation(TOUR_TRASH_TRANSLATION);
  const { record, onHandleClickBtnEdit, setLoading } = props;
  const userContext = useContext(UserContext);

  const handleEdit = () => {
    Modal.confirm({
      title: t('table.popup.title'),
      okText: t('table.popup.okBtn'),
      cancelText: t('table.popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={t('table.popup.edit')}
          isConfirmPassword
          textConfirmPassword={t('table.popup.confirmPassword')}
        />
      ),
      onOk() {
        setLoading && setLoading(true);
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        if (!userContext.user?.email || userContext.user?.email === '') {
          setLoading && setLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              setLoading && setLoading(false);
              if (onHandleClickBtnEdit) {
                onHandleClickBtnEdit(record, true);
              }
            })
            .catch((e: any) => {
              setLoading && setLoading(false);
              message.error(e?.errorMessage);
            });
        }
      },
    });
  };

  return (
    <StyledProductContainer>
      {record.product && record.product?.images && record.product.images.length > 0 ? (
        <div className="image" style={{ backgroundImage: `url('${record.product.images[0].imageUrl}')` }} />
      ) : (
        <div className="image" />
      )}
      <Tooltip placement="top" title={record.title}>
        <Typography.Text>{record.title}</Typography.Text>
      </Tooltip>
      {record?.status === TourTrashStatusType.ACTIVE && (
        <Tooltip title={t('table.tooltip.edit')}>
          <Button icon={<EditOutlined />} onClick={handleEdit} />
        </Tooltip>
      )}
    </StyledProductContainer>
  );
});

const StyledProductContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  .image {
    width: 3.125rem;
    height: 3.125rem;
    background-color: #eee;
    background-size: cover;
    background-position: center center;
    border: 1px solid #eee;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left !important;

  .ant-typography {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
